import React from 'react'
import styled from 'styled-components'

export const WaitingEvents = (): JSX.Element => {
    return (
        <Container>
            <h2>Waiting for new events ...</h2>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
